import { Children, ReactNode } from 'react';

export const PopularItems = ({ items }: { items: ReactNode }) => {
  if (Children.count(items)) {
    return <div className="flex items-center flex-wrap">{items}</div>;
  }

  return (
    <div className="flex items-center flex-wrap animate-pulse animate">
      {new Array(5).fill(null).map((x, i) => (
        <span
          className="rounded-full bg-gray-50 border border-gray-300 p-1 flex items-center mr-2 mb-1"
          key={i}
        >
          <span className="w-8 h-8 flex-none mr-2 rounded-full bg-gray-300/50" />
          <span className="w-20" />
        </span>
      ))}
    </div>
  );
};

export default PopularItems;
